<!-- src/components/LayerPage2.vue -->
<template>
  <div class="whole-container">
    <div class="header">
      <h1> Single-cell Transcriptomics </h1>
      <div class="function_description">
          <p> Single-cell RNA sequencing was performed on one control endometrium (from a patient with leiomyoma excluding endometrial disorders), one eutopic endometrium and one ectopic lesion (from a patient with adenomyosis) using the 10x Genomics platform. Data was from the study of Shi et al. (DOI: 10.1186/s13578-021-00562-z). </p>
        </div>
    </div>
    <div class="step-one"> <h1 class="custom-h1"><span class="h1-color"># </span><span>Choose the sample</span></h1>
      <div class="sample-container">
        <div class="sample-div">
          <!--
            four samples, each sample has one text name, and two images,
            show name and images.
            when hover on the sample, background color change to blue
            when click on the sample, background color change to black,
            and the sample will be selected.
          -->
          <div v-for="(sample, index) in samples" :key="sample.name" v-bind:id=sample.name class="sample_function2" @mouseover="onMouseover(index)" @mouseleave="onMouseleave(index)" @click="handleSampleClick(index)">
            <div class="sample-name">{{ sample.name }}</div>
            <div class="sample-image">
              <img :src="sample.image" :alt="'Image ' + (index + 1)" class="indent_image" />
            </div>
          </div>
          <div class="indent">
            <img :src="require('../assets/function2/func2_pic_indent.png')" class="indent_image function2_indent" />
          </div>
          <div class="clear"></div>

        </div>
      </div>
    </div>
    <div class="step-two"> 
      <h1 class="custom-h1"><span class="h1-color"># </span><span>Explore the sample expression and cell type expression of genes</span></h1>
    <h2 class="custom-h2"> Enter a list of genes (one per line) to explore their expression across samples</h2>
    <FileUpload uniqueId="function_2_1" function_name="function_2_2" v-bind:sample_choose="get_sample_choose"></FileUpload>
    <h2 class="custom-h2"> Enter a list of genes (one per line) to explore their expression across different cell types</h2>
    <FileUpload uniqueId="function_2_2" function_name="function_2_3" v-bind:sample_choose="get_sample_choose"></FileUpload>
    </div>
    
    <!-- Your content for Page 1 goes here -->
  </div>
</template>

<script>
import axios from 'axios';
import { backendIP } from '@/config.js'
import FileUpload from '@/components/FileUpload.vue';

export default {
  components: {
    FileUpload,
  },
  name: 'PageTwo',
  data() {
    return {
      hovered: false,
      active: false,
      image1_2: null,
      gene: '', // To store user input
      samples: [
        { name: "UM_CTRL",image: require("../assets/function2/func2_pic1.png"), active: false, hovered: false },
        { name: "AM_EM",image: require("../assets/function2/func2_pic2.png"), active: false, hovered: false },
        { name: "AM_EC",image: require("../assets/function2/func2_pic3.png"), active: false, hovered: false }, 
      ]
    };
  },
  computed: {
    get_sample_choose() {
      let sample_choose = [];
      for (var i = 0; i < this.samples.length; i++) {
        if(this.samples[i].active)
          sample_choose.push(this.samples[i].name);
      }
      console.log(sample_choose)
      return sample_choose;
    },
  },
  methods:{
    handleSampleClick(index){
      this.samples[index].active = !this.samples[index].active;
      //get element by key, set background color to black
      if(this.samples[index].active)
        document.getElementById(this.samples[index].name).style.backgroundColor = "#54bee2";
      else
        document.getElementById(this.samples[index].name).style.backgroundColor = "#ffffff";
      
      
      console.log(this.samples[index].name);
      console.log(this.samples[index].active);
    },
    onMouseover(index){
      this.samples[index].hovered = true;
      if(!this.samples[index].active)
        document.getElementById(this.samples[index].name).style.backgroundColor = "#54bee2";
    },
    onMouseleave(index){
      this.samples[index].hovered = false;
      if(!this.samples[index].active)
        document.getElementById(this.samples[index].name).style.backgroundColor = "#ffffff";
    },
  }
}
</script>

<style>
.sample-container{
  margin: 0 auto;
  position: relative;
  width: 90%;
}
.sample_function2{
  width: 25%;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: center;
  float: left;
  margin-left: 4%;
}

.indent{
  float: left;
  width: 10%;
  margin-top: 20px;
}

.sample_function2:hover{
  background-color: #0b536a;
}

/* .sample_function1.click{
  background-color: #000000;
} */

.indent_image{
  width: 90%;
  margin: 0 5%;
}

.function2_indent{
  margin-top: 20%;
}


.step-two{
  clear: both;
  margin: 0 auto;
}

/* .image1_2{
  height: 1000px;
} */

.image_container1_2{
  height:2000px;
}
</style>